import {validatePhoneNumber} from 'src/containers/MessageMatchers/WhatsAppForm/ButtonsForm/validate';
import {
  EMessageMatcherButtonTypes,
  MAX_URL_LENGTH,
} from 'src/containers/MessageMatchers/definitions';
import {cleanTemplateText} from 'src/containers/MessageMatchers/utils';
import {mapEmptyFieldsToUndefined} from 'src/utils';
import {joiResolver} from 'src/utils/validator';

import {COLUMNS_COUNT, TMessageMatcherPreset, TMessageMatcherPresetForm} from './definitions';

const splitListToColumns = (presets: TMessageMatcherPreset[], columns: number = COLUMNS_COUNT) =>
  presets.reduce<TMessageMatcherPreset[][]>((result, preset, index) => {
    const columnIndex = index % columns;

    result[columnIndex] = result[columnIndex] || [];
    result[columnIndex].push(preset);

    return result;
  }, []);

const resolver = joiResolver((joi, mixed) =>
  joi.object({
    name: joi
      .string()
      .min(3)
      .max(60)
      .custom((value, helpers) => {
        if (!/^[a-z0-9_]*$/.test(value)) {
          return helpers.error('invalidTemplateName');
        }

        return value;
      })
      .required(),
    subjectId: joi.number().required(),
    buttons: joi.array().items(
      joi.object({
        url: joi.when('buttonType', {
          is: EMessageMatcherButtonTypes.URL,
          then: mixed.url.max(MAX_URL_LENGTH).required(),
        }),
        phone: joi.when('buttonType', {
          is: EMessageMatcherButtonTypes.PHONE,
          then: joi.string().custom(validatePhoneNumber).required(),
        }),
      }),
    ),
  }),
);

const prepareDataForSave = (values: TMessageMatcherPresetForm) => ({
  name: values.name,
  subjectIds: values.subjectIds,
  buttons: mapEmptyFieldsToUndefined(
    values.buttons?.map((button) => ({
      ...button,
      url: button.hasUrlPostfix ? `${cleanTemplateText(button.url)}{{1}}` : button.url,
    })),
  ),
});

const prepareDataForEdit = (values: TMessageMatcherPresetForm, preset: TMessageMatcherPreset) => ({
  ...preset,
  name: values.name,
  subjectId: values.subjectId,
  subjectIds: values.subjectIds,
  content: {
    ...preset.content,
    buttons: values.buttons,
  },
});

export {splitListToColumns, resolver, prepareDataForSave, prepareDataForEdit};
